module.exports = __webpack_public_path__ + "static/media/dynamic wallet - light blue.1b35c593.svg";